import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable, of } from 'rxjs';
import { TypeOfJob } from '../models';

import { BussinesService } from '../../public/services';
import { GeneralResponse } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class WorkplaceTypeService {
  private apiService = inject(ApiService);
  private bussinesService = inject(BussinesService);

  storeWorkplace(data: TypeOfJob) {
    return this.apiService.store(
      `workplaceType?name=${data.name}&description=${data.description}&recurrence=${data.recurrence}&maxcapacity=${data.maxcapacity}
    &color=verde&blockstatus=1&icon=icono&isparking=${data.isparking}&businessid=${data.businessid}`,
      undefined
    );
  }

  deleteWorkplace(id: number) {
    return this.apiService.delete('workplaceType', id);
  }

  postWorkPlaceTypeAvailable(
    businessId: number,
    floorId: number,
    workerId: number
  ): Observable<GeneralResponse<TypeOfJob[]>> {
    return this.apiService.post<TypeOfJob[]>('workplaceType/getAvailable', {
      businessId,
      floorId,
      workerId,
    });
  }

  getWorkplaces(BusinessId?: number): Observable<GeneralResponse<TypeOfJob[]>> {
    if (BusinessId) {
      return this.apiService.get<TypeOfJob[]>(
        `workplaceType${
          BusinessId === undefined ? '' : `?businessid=${BusinessId}`
        }`
      );
    } else {
      const businessId = this.bussinesService.getBussinesId();
      console.log(businessId);
      return this.apiService.get<TypeOfJob[]>(
        `workplaceType${
          businessId === undefined ? '' : `?businessid=${businessId}`
        }`
      );
    }
  }

  getWorkplacesByFloorId(
    floorId: number
  ): Observable<GeneralResponse<TypeOfJob[]>> {
    return this.apiService.get<TypeOfJob[]>('workplaceType/floor/' + floorId);
  }

  getWorkplace(id: number): Observable<TypeOfJob> {
    return this.apiService.getById('', id);
  }

  updateWorkplace(data: TypeOfJob, id: number) {
    return this.apiService.update(
      `workplaceType/${id}?name=${data.name}&description=${
        data.description
      }&recurrence=${data.recurrence}&maxcapacity=${data.maxcapacity}
    &color=verde&blockstatus=1&icon=icono&isparking=${
      data.isparking
    }&businessid=${this.bussinesService.getBussinesId()}`,
      undefined,
      id
    );
  }
}
